// Decodifica entidades HTML que WooCommerce devuelve en nombres de producto.
//
// Vivía en `qrCodes.js`, que es el módulo del escáner y no tiene nada que ver:
// esta función la usan Catálogo, etiquetas, QR y el Resumen de ventas. Se mudó
// acá el 12-ago-2026 para que el porqué del `<textarea>` —que es lo único que
// impide reescribirla mal— se lea en el archivo que alguien va a abrir.
//
// ⚠️ EL `<textarea>` NO ES UN CAPRICHO NI UN ESTILO. La versión anterior usaba
// un `<div>`:
//
//     const el = document.createElement('div');
//     el.innerHTML = str;            // ← ejecuta markup
//     return el.textContent || str;
//
// Adentro de un `<div>`, `innerHTML` parsea el string como HTML. Medido en
// Chromium real (Playwright, 12-ago-2026): con `str = '<img src=x onerror=…>'`
// **el handler DISPARA**, aunque el `<div>` nunca se agregue al documento — el
// `<img>` se crea, arranca la descarga, falla y ejecuta el `onerror`. Un
// `<script>` no ejecuta (así lo manda la spec de HTML5), pero eso no salvaba
// nada: `<img onerror>` es el vector clásico y funcionaba.
//
// Adentro de un `<textarea>` el contenido se parsea como RCDATA: las entidades
// SÍ se decodifican, el markup NO se interpreta. Mismo resultado en todos los
// casos reales, inerte en el peligroso.
//
// Y de paso es MÁS FIEL, no solo más segura. El `<div>` se tragaba el markup:
// `'texto <em>con</em> markup'` volvía como `'texto con markup'`, o sea borraba
// parte del nombre del producto en silencio. El `<textarea>` lo devuelve tal
// cual está guardado.
//
// `DOMParser` también es inerte y se evaluó, pero se DESCARTÓ: recorta el
// espacio inicial (`'  espacios  '` → `'espacios  '`), que es una alteración
// nueva y silenciosa del dato. Cambiar una vulnerabilidad por un recorte
// invisible no es un buen canje.
//
// Diferencial medido sobre 29 casos: `<textarea>` difiere del `<div>` en 3, y
// los 3 son markup CRUDO. En los 26 restantes —entidades, vacíos, acentos,
// espacios, doble-escapado, nombres reales del catálogo— son idénticos.
export function decodeHtml(str) {
  if (!str || typeof str !== 'string') return str;
  const el = document.createElement('textarea');
  el.innerHTML = str;
  return el.value || str;
}
